<template>
    <div>
        <div class="social-login-btns">
            <div v-if="!isLoading">
                <div v-if="showAgreementText" class="agreement">
                    <input type="checkbox" v-on:click="isChecked = !isChecked">
                    <span>I have read and agree to the <a href="/tos" target="_blank">terms of service</a> & <a href="/privacy" target="_blank">privacy policy</a></span>
                    <div v-if="showError" class="error">You must agree to continue</div>
                </div>

                <a @click="authenticate('Facebook')" class="button button-fb">
                    <i class="fab fa-facebook-f"></i> Continue With Facebook
                </a>

                <a @click="authenticate('Google')" class="button button-google">
                    <i class="fab fa-google"></i> Continue With Google
                </a>
            </div>

            <div class="social-login-loading" v-if="isLoading">
                <i class="fas fa-spinner fa-spin fa-3x"></i><br>
                Logging you in with {{loginMethod}}. Please wait...
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SocialLoginButtons',
    components: {},
    props: [
        'showAgreementText'
    ],
    mounted() {
    },
    data () {
        return {
            isLoading: false,
            loginMethod: '',
            isChecked: false,
            showError: false
        }
    },
    methods: {
        authenticate: function (provider) {

            if (this.showAgreementText) {
                if (this.isChecked) {
                    this.isLoading      = true;
                    this.loginMethod    = provider;

                    window.location.href = '/auth/' + provider;
                } else {
                    this.showError = true;
                }
            } else {
                this.isLoading      = true;
                this.loginMethod    = provider;

                window.location.href = '/auth/' + provider;
            }

        }
    }
}
</script>
<style lang="scss" scoped>
.social-login-btns {
    width:100%;

    .agreement {
        margin:0 0 20px 0;
        text-transform: uppercase;

        span {
            vertical-align: super;
            font-size: 14px;
        }

        input {
            width:20px;
            height:20px;
        }

        .error {
            color: #aa1111;
            font-weight: bold;
        }
    }
}

.social-login-loading {
    padding: 10px 0 10px 0;
    text-align: center;
    font-size: 16px;
}

// Social Buttons (Login)
.button-fb {
    font-size: 19px;
    cursor: pointer;
    background: #3A5A97;
    color:#fff !important;
    text-shadow: 0 -1px 0 rgba(0,0,20,.4);
    display: inline-block;

    &:hover {
        color:#fff;
        text-decoration: none;
    }
}

.button-google {
    font-size: 19px;
    cursor: pointer;
    background: #4285f4;
    color:#fff !important;
    text-shadow: 0 -1px 0 rgba(0,0,20,.4);
    display: inline-block;

    &:hover {
        color:#fff;
        text-decoration: none;
    }
}

span a {
    color:#fff;
}
</style>
